import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e06a23c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "viewing-card-appoitment-details" }

import { computed, toRefs } from 'vue'
    import { Viewing } from '@/interface'
    import { formatDate } from '@/helpers/date'
    import { formatRelatieNaam, formatMedewerkerNaam } from '@/helpers/relatie'
    import ViewingCardTitle from '@/components/ViewingCard/ViewingCardTitle.vue'
    import FancyButton from '@/components/ui/FancyButton.vue'
    import TypeformSlideRight from '@/components/typeform/TypeformSlideRight.vue'
    import IconArrowRight from '@/components/icons/IconArrowRight.vue'

    
export default /*#__PURE__*/_defineComponent({
  props: {
    viewing: null
  },
  setup(__props: any) {

const props = __props as { viewing: Viewing }

    
    const { viewing } = toRefs(props)

    const typeformHidden = computed((): Record<string, string> => {
        if (!viewing.value) {
            return {}
        }

        return {
            aid: viewing.value.agenda.id,
            client: formatRelatieNaam(viewing.value.relatie),
            object: adres.value,
            realtor: formatMedewerkerNaam(viewing.value.medewerker),
            datetime: formatDate(viewing.value.date, 'PPPp').toLowerCase(),
        }
    })

    const adres = computed((): string => {
        const adres = viewing.value.adres

        return [adres.straat, adres.huisnummer, adres.huisnummertoevoeging, 'in', adres.plaats]
            .filter(value => value !== null && value !== '')
            .join(' ')
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ViewingCardTitle, {
      date: _unref(viewing).date
    }, null, 8, ["date"]),
    (_unref(viewing).date < new Date() && _unref(viewing).response === null)
      ? (_openBlock(), _createBlock(TypeformSlideRight, {
          key: 0,
          form: _unref(viewing).form,
          hidden: _unref(typeformHidden)
        }, {
          default: _withCtx(({ toggle }) => [
            _createVNode(FancyButton, {
              title: _ctx.$t('action.reviewViewing'),
              color: "completed",
              onClick: toggle
            }, {
              icon: _withCtx(() => [
                _createVNode(IconArrowRight, { size: 16 })
              ]),
              _: 2
            }, 1032, ["title", "onClick"])
          ]),
          _: 1
        }, 8, ["form", "hidden"]))
      : _createCommentVNode("", true)
  ]))
}
}

})